import React, { useState, ChangeEvent, KeyboardEvent } from "react";
import "./CSS/PurchaseOrdersSearchBar.css";
import { useAppSelector } from "../../state/hooks";
import { SearchParams } from "../../atomic_components/types";

type Props = {
  onSearch: (query: string) => void;
};

function PurchaseOrdersListingSearchBar({ onSearch }: Props) {
  // const searchTextFromStore = useAppSelector((state) => state.search_text);

  // const [searchQuery, setSearchQuery] = useState(searchTextFromStore);
  const [searchQuery, setSearchQuery] = useState("");

  const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      console.log(searchQuery);
      onSearch(searchQuery);
    }
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length == 0) onSearch(e.target.value);
    setSearchQuery(e.target.value);
  };

  return (
    <div className="purchase-orders-search-bar">
      <input
        type="text"
        placeholder="Search po id, sku_id ... "
        value={searchQuery}
        onChange={handleInputChange}
        onKeyPress={handleKeyPress}
      />
    </div>
  );
}

export default PurchaseOrdersListingSearchBar;
